import { ENDPOINT } from '~/constants';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import {
  AccountingReferencesDetailsQueryParams,
  AccountingReferencesDetailsResponse,
} from './types';
import {
  zodAccountingReferencesDetailsQueryParamsSchema,
  zodAccountingReferencesDetailsResponseSchema,
} from './validations';

/**
 * Fetches the data for accounting references details from the API with the given query parameters.
 *
 * @param queryParams - The query parameters for fetching the accounting references details.
 * @param options - Additional options for the request (e.g., abort signal).
 * @returns The accounting references details data including paginated table items.
 * @throws Error if the API request fails.
 * @see https://app.dev.vestigas.com/redoc#tag/Accounting-Reference/operation/get_accounting_reference_activity_table_accounting_reference_statistics_details_post
 */
export const fetchAccountingReferencesDetails = async (
  queryParams: AccountingReferencesDetailsQueryParams,
  options?: KyRequestOptions,
) => {
  const response = await vestigasApi
    .post(ENDPOINT.ANALYTICS.GET_ACCOUNTING_REFERENCES_DETAILS(), {
      json: queryParams,
      validate: {
        body: zodAccountingReferencesDetailsQueryParamsSchema,
      },
      ...options,
    })
    .json<AccountingReferencesDetailsResponse>();

  // Validate the response
  const validatedResponse =
    zodAccountingReferencesDetailsResponseSchema.parse(response);

  return validatedResponse;
};
